<template>
  <b-card
    v-if="orgCountByRegionAndType"
    no-body
  >
    <b-card-header>
      <b-card-title>{{ $t('Number of universities and institutes in the region') }}</b-card-title>
    </b-card-header>
    <!-- chart -->
    <b-card-body>
      <chartjs-component-bar-chart
        v-if="barchartData"
        :data="barchartData"
        :options="barChartOptions"
      />
    </b-card-body>
  </b-card>
</template>
<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody,
} from 'bootstrap-vue'
import chartjsData from './chartjsData'
import ChartjsComponentBarChart from './charts-components/ChartjsComponentBarChart.vue'

export default {
  name: 'OrgCountByTypeAndOrgAdminComponent',
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    ChartjsComponentBarChart,
  },
  data() {
    return {
      barchartData: null,
    }
  },
  computed: {
    orgCountByRegionAndType() {
      return this.$store.state[this.MODULE_NAME].orgCountByRegionAndType
    },
  },
  created() {
    this.$store.dispatch(`${this.MODULE_NAME}/orgCountByRegionAndType`).then(() => {
      this.barchartData = this.$store.getters[`${this.MODULE_NAME}/getOrgCountByRegionAndTypeForBarChart`]
    })
  },
  methods: {
  },
  setup() {
    const MODULE_NAME = 'statistic'
    return {
      MODULE_NAME,
      ...chartjsData,
    }
  },
}
</script>

<style scoped>

</style>
